import axios, { encodeData } from "../utils/axios";

export const fetchDocuments = async () => {
  const res = await axios.get("/documents").catch((error) => {
    if (error.response) {
      console.error(error);
    }
  });

  return res.data;
};

export const createDocument = async (newDocument) => {
  await axios.post("/documents/create", encodeData(newDocument));
};

export const updateDocument = async (updatedDocument) => {
  await axios.put("/documents/update", encodeData(updatedDocument));
};

export const deleteDocument = async (oldDocument) => {
  await axios.delete("/documents/delete", { data: encodeData(oldDocument) });
};


// export const fileUpload = async (file, id, code) => {
//   if (file) {
//     const formData = new FormData();
//     console.log("fileUpload");
//     // console.log(id);
//     // console.log(code);
//     // console.log(file);

//     formData.append('file', file);
//     formData.append('id', id);
//     formData.append('code', code);
//     console.log(formData);
//     // console.log({ data: encodeData(formData) });

//     console.log("fileUpload");
//     try {
//       await axios.post("/documents/fileUpload", formData);
//       // const response = await axios.post('/documents/fileupload', formData, {
//       //   headers: {
//       //     'Content-Type': 'multipart/form-data'
//       //   }
//       // });
//       console.log('File uploaded successfully');
//     } catch (error) {
//       console.error('Error uploading file', error);
//     }
//   }
// };



// export const createSingleApplication = async (newApplication) => {
//   const res = await axios.post(
//     "/applications/create-one",
//     encodeData(newApplication)
//   );
//   return res;
// };


export const fileUpload = async (datafile) => {
  if (datafile) {
    // const formData = new FormData();
    // console.log("fileUpload");

    // formData.append('file', file);
    // formData.append('id', id);
    // formData.append('code', code);

    // console.log(formData.get('file'));

    await axios.post("/documents/fileUpload", encodeData(datafile));

    //   try {
    //     const response = await axios.post("/documents/fileUpload", formData, {
    //       headers: {
    //         'Content-Type': 'multipart/form-data'
    //       }
    //     });
    //     console.log('File uploaded successfully', response.data);
    //   } catch (error) {
    //     console.error('Error uploading file', error);
    //   }
  }
};

